const bubbleUtils = {
    calculateSeparationAngles (shapeModel) {
        const center = {x: shapeModel.x + shapeModel.width / 2, y: shapeModel.y + shapeModel.height / 2};

        // variables for the location of the corners relative to the center.
        const rightAngle = 0;
        const bottomAngle = 90;
        const leftAngle = 180;
        const topAngle = -90;
        const upperRightAngle = Math.atan2(shapeModel.y - center.y, (shapeModel.x + shapeModel.width) - center.x) * 180 / Math.PI;
        const lowerRightAngle = Math.atan2((shapeModel.y + shapeModel.height) - center.y, (shapeModel.x + shapeModel.width) - center.x) * 180 / Math.PI;
        const lowerLeftAngle = Math.atan2((shapeModel.y + shapeModel.height) - center.y, shapeModel.x - center.x) * 180 / Math.PI;
        const upperLeftAngle = Math.atan2(shapeModel.y - center.y, shapeModel.x - center.x) * 180 / Math.PI;

        return {
            rightAngle,
            bottomAngle,
            leftAngle,
            topAngle,
            upperRightAngle,
            lowerRightAngle,
            lowerLeftAngle,
            upperLeftAngle
        };
    },
    getActiveSector (shapeModel, point) {
        const { x, y, width, height } = shapeModel;
        const separationAngle = this.calculateSeparationAngles(shapeModel);
        const center = {x:x + width/2, y:y + height/2};
        const angle = Math.atan2(point.y - center.y, point.x - center.x) * 180 / Math.PI;

        switch (true) {
            case (angle >= separationAngle.rightAngle && angle < separationAngle.lowerRightAngle): {
                return 1;
            }
            case (angle >= separationAngle.lowerRightAngle && angle < separationAngle.bottomAngle): {
                return 2;
            }
            case (angle >= separationAngle.bottomAngle && angle < separationAngle.lowerLeftAngle): {
                return 3;
            }
            case (angle >= separationAngle.lowerLeftAngle && angle <= separationAngle.leftAngle): {
                return 4;
            }
            case (angle >= -separationAngle.leftAngle && angle < separationAngle.upperLeftAngle): {
                return 5;
            }
            case (angle >= separationAngle.upperLeftAngle && angle < separationAngle.topAngle): {
                return 6;
            }
            case (angle >= separationAngle.topAngle && angle < separationAngle.upperRightAngle): {
                return 7;
            }
            case (angle >= separationAngle.upperRightAngle && angle < separationAngle.rightAngle): {
                return 8;
            }
        }

        return 0;
    },
    getFreeSector(shapeModel) {
        var activeSectors = [];
        var sector;

        if (shapeModel.cx) {
            sector = this.getActiveSector(shapeModel, {x: shapeModel.cx, y: shapeModel.cy});

            if (activeSectors.indexOf(sector) == -1)
                activeSectors.push(sector);
        }

        if (shapeModel.cx1) {
            sector = this.getActiveSector(shapeModel, {x: shapeModel.cx1, y: shapeModel.cy1});

            if (activeSectors.indexOf(sector) == -1)
                activeSectors.push(sector);
        }

        if (shapeModel.cx2) {
            sector = this.getActiveSector(shapeModel, {x: shapeModel.cx2, y: shapeModel.cy2});

            if (activeSectors.indexOf(sector) == -1)
                activeSectors.push(sector);
        }

        if (shapeModel.cx3) {
            sector = this.getActiveSector(shapeModel, {x: shapeModel.cx3, y: shapeModel.cy3});

            if (activeSectors.indexOf(sector) == -1)
                activeSectors.push(sector);
        }

        if (shapeModel.cx4) {
            sector = this.getActiveSector(shapeModel, {x: shapeModel.cx4, y: shapeModel.cy4});

            if (activeSectors.indexOf(sector) == -1)
                activeSectors.push(sector);
        }

        if (activeSectors.indexOf(3) == -1)
            return 3;

        if (activeSectors.indexOf(2) == -1)
            return 2;

        if (activeSectors.indexOf(7) == -1)
            return 7;

        if (activeSectors.indexOf(6) == -1)
            return 6;

        if (activeSectors.indexOf(8) == -1)
            return 8;

        if (activeSectors.indexOf(5) == -1)
            return 5;
    },
    getNewControlPoint(shapeModel) {
        var point = {};
        var sector = this.getFreeSector(shapeModel);
        var xValue = 1;
        var yValue = 1;

        switch (sector) {
            case 3: {
                xValue = 0;
                yValue = 1.6;
                break;
            }
            case 2: {
                xValue = 1;
                yValue = 1.6;
                break;
            }
            case 7: {
                xValue = 1;
                yValue = - 1;
                break;
            }
            case 6: {
                xValue = 0;
                yValue = - 1;
                break;
            }
            case 8: {
                xValue = 1.6;
                yValue = 0;
                break;
            }
            case 5: {
                xValue = - 0.6;
                yValue = 0;
                break;
            }
        }

        point.x = shapeModel.x + xValue * shapeModel.width;
        point.y = shapeModel.y + yValue * shapeModel.height;

        return point;
    }
};

export default bubbleUtils;



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/utils/BubblesUtils.js
 **/